module.exports = __webpack_public_path__ + "img/U7.feda30e0.png";